var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDown == true)?_c('div',{staticClass:"mongolia",on:{"click":function($event){return _vm.mongolia()}}},[_c('img',{attrs:{"src":require("@/assets/image/dakai.png"),"alt":""}}),_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("点击右上角“...”"),_c('br'),_vm._v("选择在“浏览器”打开"),_c('br'),_vm._v("下载App")])
}]

export { render, staticRenderFns }